import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';

import { Box } from '@zillow/constellation-10';

export const reviewSectionStyles = css.raw({
  marginBottom: '800',
});

export const StyledReviewTitleRow = styled(Box, {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '400',
  },
});

export const StyledIconPlaceholder = styled(Box, {
  base: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '200',
    width: '15px',
    flexShrink: 0,
  },
});

export const StyledReviewSectionTitle = styled(Box, {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '100',

    '& > *:not(:last-child)': {
      marginRight: '200 !important',
    },
  },
});

export const componentStyles = css.raw({
  border: 'none',
  padding: 0,
});

export const propertyPhotoStyles = css.raw({
  borderRadius: '200',
  marginRight: {
    base: '200',
    md: '400',
  },
  minHeight: '104px',
  width: {
    base: '93px',
    md: '156px',
  },
  alignSelf: 'center',
  flexShrink: 0,
});

export const addressDetailsStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flexGrow: 1,
  minWidth: 0,
});

// this needs to be <li/> to comply with its parent <ul/>
export const StyledVerticalDivider = styled('li', {
  base: {
    alignSelf: 'center',
    backgroundColor: 'gray.400',
    display: 'inline-flex',
    height: '12px',
    margin: { base: '0 {spacing.100}', md: '0 {spacing.200}' },
    width: '1px',
  },
});
